import React from 'react';
import { EarlyPayoutsContainer } from '../../../containers';

export const EarlyPayout = () => <EarlyPayoutsContainer />;
